module.exports = __webpack_public_path__ + "static/media/amps.03f9becf.svg";